module.exports = __webpack_public_path__ + "static/media/23.c641e8b4.jpg";